import { useSelector } from "react-redux";
import UniqueDefinitions from "../../../../components/DataCollection/Unifier/UniqueDefinitions/UniqueDefinitions";
import Page404 from "../../../../components/Page404/Page403";
import { selectUserData } from "../../../../features/userSlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
// import ComingSoon from "../../../../components/ComingSoon/ComingSoon";

const UniqueDefinitionsScreen = () => {
  const response = useSelector(selectUserData);
  const hasUnifierViewUniqueDefinitions = CheckPermissions(
    response?.data?.products?.data_collection,
    "unifier",
    "view_unique_definitions"
  );
  // const react_env = import.meta.env.VITE_ENV;

  return (
    <>
      {hasUnifierViewUniqueDefinitions ? (
        <>
          <UniqueDefinitions />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default UniqueDefinitionsScreen;
